import { render, staticRenderFns } from "./CatalogoDigitalProductsTab.vue?vue&type=template&id=08c58763&scoped=true"
import script from "./CatalogoDigitalProductsTab.vue?vue&type=script&lang=js"
export * from "./CatalogoDigitalProductsTab.vue?vue&type=script&lang=js"
import style0 from "./CatalogoDigitalProductsTab.vue?vue&type=style&index=0&id=08c58763&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c58763",
  null
  
)

export default component.exports